import styled from 'styled-components';
import Input from '../Input';
import Button from '../../../../../BuildingBlocks/Button';
import MapButton from '../../../../MapLayerButton';
import { mixins, colors } from '../../../../../css';

const { pxToRem } = mixins;
const { colorGrey04 } = colors;

const MapButtonContainer = styled.div`
  display: flex;
  padding: ${pxToRem(5)} 0;
  flex-wrap: ${({ wrapChildren }) => (wrapChildren ? 'wrap' : 'nowrap')};
`;

const StyledMapButton = styled(MapButton)`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : `calc((100% - ${pxToRem(20)}) / 2)`)};
  margin-bottom: ${pxToRem(15)};
  &:nth-of-type(2n + 1) {
    margin-right: ${pxToRem(20)};
  }
  > div {
    line-height: 1.5rem;
  }
  white-space: nowrap;
  > div {
    max-width: calc(100% - 35px);
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

const Section = styled.section`
  border-bottom: 1px solid ${colorGrey04};
  border-bottom-width: ${({ divider }) => (divider ? '1px' : '0')};
  padding: ${pxToRem(22)} 0;
`;

const SeeMoreContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const SeeMore = styled(Button)`
  color: #000;
  padding: 0;
`;
const StyledInput = styled(Input)`
  flex: 0 0 35%;
  width: 35%;
`;

const InlineContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
`;

export default {
  Section,
  SeeMore,
  MapButton: StyledMapButton,
  MapButtonContainer,
  SeeMoreContainer,
  Input: StyledInput,
  InlineContainer
};
